import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Box, Typography, Autocomplete } from '@mui/material';
import { users } from '../../data/sampleData';

interface CaseDetailsFormProps {
  formData: {
    title: string;
    clientId: string;
    practiceArea: string;
    description: string;
  };
  onChange: (field: string, value: string) => void;
}

export const CaseDetailsForm: React.FC<CaseDetailsFormProps> = ({
  formData,
  onChange,
}) => {
  // Filter users to only show clients
  const clients = users.filter(user => user.role === 'client');

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Case Title"
          required
          value={formData.title}
          onChange={(e) => onChange('title', e.target.value)}
          placeholder="e.g., Smith v. Johnson Construction"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Autocomplete
          value={clients.find(client => client.id === formData.clientId) || null}
          onChange={(_, newValue) => onChange('clientId', newValue?.id || '')}
          options={clients}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Client"
              required
              placeholder="Search clients..."
            />
          )}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Box>
                <Typography>{option.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {option.email}
                </Typography>
              </Box>
            </Box>
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel>Practice Area</InputLabel>
          <Select
            value={formData.practiceArea}
            label="Practice Area"
            onChange={(e) => onChange('practiceArea', e.target.value)}
          >
            <MenuItem value="personal-injury">Personal Injury</MenuItem>
            <MenuItem value="family-law">Family Law</MenuItem>
            <MenuItem value="corporate">Corporate Law</MenuItem>
            <MenuItem value="criminal">Criminal Defense</MenuItem>
            <MenuItem value="real-estate">Real Estate</MenuItem>
            <MenuItem value="employment">Employment Law</MenuItem>
            <MenuItem value="intellectual-property">Intellectual Property</MenuItem>
            <MenuItem value="immigration">Immigration</MenuItem>
            <MenuItem value="estate-planning">Estate Planning</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Case Description"
          multiline
          rows={4}
          required
          value={formData.description}
          onChange={(e) => onChange('description', e.target.value)}
          placeholder="Provide a detailed description of the case"
        />
      </Grid>
    </Grid>
  );
};